import { GridLegacy as Grid, useTheme } from "@mui/material";
import { gql } from "generated-graphql";
import { currentTierIIReportingYear } from "encamp-shared/src/constants/tierii";
import { useQuery } from "@apollo/client";
import { TierIiReportKind } from "generated-graphql/graphql";
import { useOmnisearchInput } from "hooks/useOmnisearchDatagrid/useOmnisearchInput";
import { useEffect, useState } from "react";
import { WorkflowOverviewKeyMetrics } from "./WorkflowOverviewKeyMetrics";
import { WorkflowOverviewActivitiesByAssigneesCard } from "./WorkflowOverviewActivitiesByAssigneesCard";

const WORKFLOW_OVERVIEW_STATS = gql(`
    query WorkflowOverviewStats($year: Int!, $reportKinds: [TierIIReportKind!]!) {
      workflowOverviewSeasonSummary(year: $year, reportKinds: $reportKinds) {
        year
        workflowsCountError
        workflowsCountWaitForAll
        workflowsCountHuman
        staffSummaries {
          id
          name
          reportCount
          completedCount
        }
      }
    }
  `);

export function WorkflowOverviewStats() {
  const theme = useTheme();

  const { omnisearch, getOmnisearchValue } = useOmnisearchInput({
    isURLDriven: true,
    initialFilters: [],
  });

  const yearFilterValue = getOmnisearchValue("reportingYear");

  const [reportKinds, setReportKinds] = useState(
    (getOmnisearchValue("reportKind")?.split("|") as TierIiReportKind[]) ?? [
      ...Object.values(TierIiReportKind),
    ]
  );
  const [year, setYear] = useState(
    yearFilterValue ? parseInt(yearFilterValue) : currentTierIIReportingYear
  );

  const { data, loading } = useQuery(WORKFLOW_OVERVIEW_STATS, {
    fetchPolicy: "network-only",
    variables: {
      year,
      reportKinds,
    },
  });

  useEffect(() => {
    setReportKinds(
      (getOmnisearchValue("reportKind")?.split("|") as TierIiReportKind[]) ?? [
        ...Object.values(TierIiReportKind),
      ]
    );
    setYear(
      yearFilterValue ? parseInt(yearFilterValue) : currentTierIIReportingYear
    );
  }, [getOmnisearchValue, omnisearch]);

  return (
    <>
      <Grid item xs={12} marginBottom={theme.spacing(3)}>
        <Grid container spacing={theme.spacing(3)}>
          <Grid item lg={7} xs={12} sx={{ height: "471px" }}>
            <WorkflowOverviewActivitiesByAssigneesCard
              data={data?.workflowOverviewSeasonSummary?.staffSummaries}
              loading={loading}
            />
          </Grid>
          <Grid item lg={5} xs={12} sx={{ height: "471px" }}>
            <WorkflowOverviewKeyMetrics
              data={data?.workflowOverviewSeasonSummary}
              loading={loading}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
